export const RENT_MIN = 1000;
export const RENT_MAX = 14000;
export const RENT_STEP = 100;
export const RENT_DEFAULT = RENT_MAX;

export const ROOMS_MIN = 1;
export const ROOMS_MAX = 6;
export const ROOMS_STEP = 1;
export const ROOMS_DEFAULT = ROOMS_MIN;

export const SIZE_MIN = 10;
export const SIZE_MAX = 140;
export const SIZE_STEP = 1;
export const SIZE_DEFAULT = SIZE_MIN;
